import { clsx } from 'clsx';
import { ObjectsKeysCell } from './ObjectsKeysCell/ObjectsKeysCell';
import { FieldsCountCell } from './FieldsCountCell';
import { ObjectConfig, ObjectConfigStatus } from '../../interfaces/object';
import { ObjectsHeaderColumn } from '../../interfaces/object-header';
import { Tooltip } from '../../../../tooltip/Tooltip';
import { Checkbox } from '../../../../checkbox/Checkbox';
import { OnDefineKeysClick } from './ObjectsKeysCell/interface';

export interface ObjectCellProps {
  isViewMode: boolean;
  cellKey: string;
  cellHeader: ObjectsHeaderColumn;
  objectRow: ObjectConfig;
  index: number;
  onDefineKeysClick: OnDefineKeysClick;
  onObjectSelectionChange: (included: boolean) => void;
}

export function ObjectCell({
  isViewMode,
  cellKey,
  cellHeader,
  objectRow,
  index,
  onDefineKeysClick,
  onObjectSelectionChange
}: ObjectCellProps) {
  switch (cellKey) {
    case 'keys':
      return (
        <ObjectsKeysCell
          isViewMode={isViewMode}
          cellHeader={cellHeader}
          keys={objectRow.keys}
          onDefineKeysClick={onDefineKeysClick}
        />
      );

    case 'fieldCount':
      return <FieldsCountCell fieldsCount={objectRow[cellKey]} />;

    default: {
      const cellValue = objectRow[cellKey] as string;

      return (
        <div className='center-flex-row overflow-hidden'>
          {index === 0 && !isViewMode ? (
            <Tooltip
              dataId={cellValue}
              title={objectRow.statusReason}
              disabled={objectRow.isEditable}
            >
              <div className='d-flex mr-2'>
                <Checkbox
                  dataId={cellValue}
                  className='flex-shrink-0'
                  disabled={!objectRow.isEditable}
                  checked={objectRow.status === ObjectConfigStatus.ACTIVE}
                  onChange={() =>
                    onObjectSelectionChange(objectRow.status !== ObjectConfigStatus.ACTIVE)
                  }
                />
              </div>
            </Tooltip>
          ) : null}

          <Tooltip dataId='' title={cellValue} enableOnTextOverflow>
            <span
              data-id='object-cell-value'
              className={clsx('text-ellipsis', !objectRow.isConfigurable && 'text-disabled')}
            >
              {cellValue}
            </span>
          </Tooltip>
        </div>
      );
    }
  }
}
